import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useOptionalTabContext } from "@/contexts/TabContext";

/**
 * Drop-in replacement for useNavigate().
 * When inside a TabProvider (desktop), calls openTab().
 * Otherwise falls back to standard router navigate.
 */
export function useTabNavigate() {
  const tabCtx = useOptionalTabContext();
  const routerNavigate = useNavigate();

  return useCallback(
    (pathOrDelta: string | number, options?: { label?: string; state?: any; replace?: boolean }) => {
      if (typeof pathOrDelta === "number") {
        routerNavigate(pathOrDelta);
        return;
      }
      if (tabCtx) {
        tabCtx.openTab(pathOrDelta, options?.label);
      } else {
        routerNavigate(pathOrDelta, { state: options?.state, replace: options?.replace });
      }
    },
    [tabCtx, routerNavigate],
  );
}
